import { createReducer } from 'by-react-utils'

type ContentState = {
  +featured: []
}

export const initialState: ContentState = {
  featured: [],
  contents: {}
}

export const ActionTypes = {
  SET_FEATURED: 'SET_FEATURED',
  SET_PAGE_CONTENT: 'SET_PAGE_CONTENT'
}

export default createReducer(initialState, {
  [ActionTypes.SET_FEATURED]: (state, { featured }) => ({
    ...state,
    featured: [...featured]
  }),

  [ActionTypes.SET_PAGE_CONTENT]: (state, { page, contents }) => ({
    ...state,
    contents: {
      ...state.contents,
      [page]: 'length' in contents ? [...contents] : { ...contents }
    }
  })
})



// WEBPACK FOOTER //
// ./src/store/reducers/Content.js